var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentCategory
    ? _c(
        "div",
        [
          _c("notifications", { attrs: { group: "foo" } }),
          !_vm.buildYourJewelMode
            ? _c("Breadcrumb", {
                staticClass: "breadcrumb-list",
                on: { navigateTo: _vm.selectCategory }
              })
            : _vm._e(),
          _vm.isSectionChecked("PRECONFIGURED_D_VS")
            ? _c("div", { staticClass: "preconfigured-banner" }, [
                _vm._v(" " + _vm._s(_vm.$t("PRECONFIGURED_D_VS_banner")) + " ")
              ])
            : _vm._e(),
          !_vm.isSearching
            ? _c(
                "div",
                {
                  staticClass: "col row px-0 ml-0 mt-2 results",
                  class: {
                    "bg-theme-2": _vm.theme !== 1,
                    "ama-results": _vm.isAma
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-12 text-center d-md-none px-0" },
                    [
                      _vm.searchJewel.text
                        ? _c("h5", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("searchResultsFor")) +
                                ' "' +
                                _vm._s(_vm.searchJewel.text) +
                                '" '
                            )
                          ])
                        : _vm._e(),
                      _vm.step === 1
                        ? _c(
                            "div",
                            _vm._l(_vm.subCategories, function(subCategory) {
                              return _c(
                                "div",
                                {
                                  key: subCategory.id,
                                  staticClass:
                                    "text-center side-part-mobile mb-3",
                                  class: {
                                    "side-part-mobile-2": _vm.theme === 2
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.selectSub(
                                        subCategory.id !==
                                          _vm.subCategorySelectedId
                                          ? subCategory
                                          : null
                                      )
                                      _vm.step = 2
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row mx-0 subcategory-mobile"
                                    },
                                    [
                                      _c("div", { staticClass: "col-5" }, [
                                        _c(
                                          "div",
                                          { staticClass: "border-item-mobile" },
                                          [
                                            _c("img", {
                                              staticClass: "w-100 p-2",
                                              attrs: {
                                                src:
                                                  _vm.baseImageUrl +
                                                  subCategory.imgPath
                                              }
                                            })
                                          ]
                                        )
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col text-left py-2 px-1"
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass: "mb-0",
                                              class: [
                                                _vm.theme === 1
                                                  ? "py-5"
                                                  : "category-mobile-name py-4 pl-2"
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(subCategory.name) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "text-right",
                                              class: [
                                                "show-all-btn-" + _vm.theme
                                              ]
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-primary text-lowercase",
                                                  class:
                                                    _vm.currentCategory
                                                      .productType
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("show_all")
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm.step === 2
                        ? _c("div", [
                            _c("div", { staticClass: "text-center" }, [
                              _c("div", { staticClass: "swiper-container" }, [
                                _c("div", { staticClass: "swiper-slides" }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "swiper",
                                          rawName: "v-swiper:mySwiper",
                                          value: _vm.swiperOptions,
                                          expression: "swiperOptions",
                                          arg: "mySwiper"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "swiper-wrapper" },
                                        _vm._l(_vm.stoneTypes, function(stone) {
                                          return _c(
                                            "div",
                                            {
                                              key: stone.id,
                                              staticClass:
                                                "swiper-slide mobile-stone"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "w-100 mt-1 mb-1",
                                                attrs: {
                                                  src:
                                                    _vm.baseImageUrl +
                                                    stone.image
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.selectStone(
                                                      _vm.isStoneSelected(stone)
                                                        ? null
                                                        : stone
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm.theme === 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-3 col-lg-2 h-100 pl-0 side-part d-none d-md-block"
                        },
                        [
                          _vm.isGioielleriaItalianaB2B &&
                          this.currentCategory.productType === "JEWELLERY"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rounded-side-filter mt-2 border-left-0"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("section")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._l(_vm.jewelSections, function(section) {
                                    return section != "OFF_PLATFORM" ||
                                      _vm.credential.isBO
                                      ? _c(
                                          "div",
                                          {
                                            key: section,
                                            staticClass:
                                              "labelCatFilterDiv form-check text-left pl-5"
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "form-check-label labelCatFilter cursor-pointer",
                                                attrs: {
                                                  for: section + "Checkbox"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t(section)) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c("input", {
                                              staticClass: "form-check-input",
                                              attrs: {
                                                id: section + "Checkbox",
                                                type: "checkbox"
                                              },
                                              domProps: {
                                                checked: _vm.isSectionChecked(
                                                  section
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.toggleSectionFilter(
                                                    section
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "labelCatFilterDiv form-check text-left pl-5"
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "form-check-label labelCatFilter cursor-pointer",
                                          attrs: { for: "fastDeliveryCheckbox" }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("fastDelivery")) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c("input", {
                                        staticClass: "form-check-input",
                                        attrs: {
                                          id: "fastDeliveryCheckbox",
                                          type: "checkbox"
                                        },
                                        domProps: {
                                          checked:
                                            _vm.searchJewel.minAvailability > 0
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.onChangeFastDelivery()
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.isAma &&
                          this.currentCategory.productType === "AMA_JEWELLERY"
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded-side-filter mt-2 border-left-0"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase"
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("section")) + " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "labelCatFilterDiv form-check text-left pl-5"
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "form-check-label labelCatFilter cursor-pointer",
                                        attrs: { for: "newin_checkbox" }
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("NEW_IN")) + " "
                                        )
                                      ]
                                    ),
                                    _c("input", {
                                      staticClass: "form-check-input",
                                      attrs: {
                                        id: "newin_checkbox",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: _vm.isSectionChecked("NEW_IN")
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.toggleSectionFilter(
                                            "NEW_IN"
                                          )
                                        }
                                      }
                                    })
                                  ]
                                ),
                                !_vm.isSectionChecked("AMA_COLORE")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "labelCatFilterDiv form-check text-left pl-5"
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "form-check-label labelCatFilter cursor-pointer",
                                            attrs: { for: "aria_checkbox" }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("aria_collection")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            id: "aria_checkbox",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: _vm.isSectionChecked(
                                              "ARIA"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.toggleSectionFilter(
                                                "ARIA"
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.credential.isBO
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "labelCatFilterDiv form-check text-left pl-5"
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "form-check-label labelCatFilter cursor-pointer",
                                            attrs: {
                                              for: "offPlatform_checkbox"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("OFF_PLATFORM")) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            id: "offPlatform_checkbox",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: _vm.isSectionChecked(
                                              "OFF_PLATFORM"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.toggleSectionFilter(
                                                "OFF_PLATFORM"
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm.getFilteredCategories(
                            _vm.currentCategory.productType
                          ).length > 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rounded-side-filter mt-2 border-left-0"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase",
                                          class: _vm.currentCategory.productType
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("category")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.getFilteredCategories(
                                      _vm.currentCategory.productType
                                    ),
                                    function(category) {
                                      return _c(
                                        "div",
                                        {
                                          key: category.id,
                                          staticClass:
                                            "labelCatFilterDiv form-check text-left pl-5",
                                          on: {
                                            click: function($event) {
                                              return _vm.selectCategory(
                                                category.id !==
                                                  _vm.currentCategory.id
                                                  ? category
                                                  : {
                                                      productType:
                                                        _vm.currentCategory
                                                          .productType
                                                    }
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "form-check-label labelCatFilter cursor-pointer",
                                              attrs: { for: category.id }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(category.name) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c("input", {
                                            staticClass: "form-check-input",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked:
                                                _vm.currentCategory.id ==
                                                category.id
                                            }
                                          })
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.currentCategory.id && _vm.subCategories.length > 1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rounded-side-filter mt-2 border-left-0"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase",
                                          class:
                                            _vm.currentCategory.productType,
                                          on: {
                                            click: function($event) {
                                              return _vm.selectSub()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("models")) + " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._l(_vm.subCategories, function(
                                    subCategory
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: subCategory.id,
                                        staticClass:
                                          "labelCatFilterDiv form-check text-left pl-5",
                                        on: {
                                          click: function($event) {
                                            return _vm.selectSub(
                                              subCategory.id !==
                                                _vm.subCategorySelectedId
                                                ? subCategory
                                                : null
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "form-check-label labelCatFilter cursor-pointer",
                                            attrs: { for: subCategory.id }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(subCategory.name) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked:
                                              _vm.subCategorySelectedId ==
                                              subCategory.id
                                          }
                                        })
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          !_vm.buildYourJewelMode
                            ? _c("div", [
                                _vm.stoneTypes.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "rounded-side-filter mt-2 border-left-0"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase",
                                            class:
                                              _vm.currentCategory.productType,
                                            on: {
                                              click: function($event) {
                                                return _vm.selectStone(null)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("stoneType")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "text-left pl-5" },
                                  [
                                    !_vm.currentCategory.productType
                                      ? _c(
                                          "p",
                                          { staticClass: "stone-type-title" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("jewelleryStones")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.stoneTypes.filter(function(s) {
                                        return s.jewellery
                                      }),
                                      function(stone) {
                                        return _c("img", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.top",
                                              value: { content: stone.name },
                                              expression:
                                                "{ content: stone.name }",
                                              modifiers: { top: true }
                                            }
                                          ],
                                          key: stone.color + "-" + stone.shape,
                                          staticClass:
                                            "rounded-circle mt-2 cursor-pointer",
                                          style: {
                                            border: _vm.isStoneSelected(stone)
                                              ? "1px solid"
                                              : ""
                                          },
                                          attrs: {
                                            src: _vm.baseImageUrl + stone.image,
                                            height: "40",
                                            width: "40"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.selectStone(
                                                _vm.isStoneSelected(stone)
                                                  ? null
                                                  : stone
                                              )
                                            }
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm.buildYourJewelMode &&
                          _vm.stoneShapes.length > 1 &&
                          _vm.buildYourJewelMode == "SETTING"
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded-side-filter mt-2 border-left-0"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase",
                                        class: _vm.currentCategory.productType,
                                        on: {
                                          click: function($event) {
                                            return _vm.selectStoneShape(null)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("stoneShape")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "text-left pl-5" },
                                  _vm._l(_vm.stoneShapes, function(shape) {
                                    return _c("img", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.top",
                                          value: { content: shape.id },
                                          expression: "{ content: shape.id }",
                                          modifiers: { top: true }
                                        }
                                      ],
                                      key: shape.id,
                                      staticClass:
                                        "rounded-circle mt-2 cursor-pointer",
                                      style: {
                                        border:
                                          _vm.stoneShapeSelectedId == shape.id
                                            ? "1px solid"
                                            : ""
                                      },
                                      attrs: {
                                        src: _vm.getShapeImage(shape.id),
                                        height: "40",
                                        width: "40"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectStoneShape(
                                            shape.id !==
                                              _vm.stoneShapeSelectedId
                                              ? shape
                                              : null
                                          )
                                        }
                                      }
                                    })
                                  }),
                                  0
                                )
                              ])
                            : _vm._e(),
                          !_vm.isAccessoryCategory
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "rounded-side-filter mt-2 border-left-0"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase",
                                      class: _vm.currentCategory.productType,
                                      on: {
                                        click: function($event) {
                                          return _vm.selectGold()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("goldColor")) + " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.isAccessoryCategory
                            ? _c(
                                "div",
                                { staticClass: "text-left pl-5" },
                                _vm._l(_vm.golds, function(gold) {
                                  return _c("img", {
                                    key: gold.id,
                                    staticClass:
                                      "rounded-circle mt-2 mr-2 cursor-pointer",
                                    style: {
                                      border:
                                        _vm.goldSelectedId == gold.goldType
                                          ? "1px solid"
                                          : ""
                                    },
                                    attrs: {
                                      src: _vm.baseImageUrl + gold.image,
                                      height: "40",
                                      width: "40"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectGold(
                                          gold.goldType !== _vm.goldSelectedId
                                            ? gold
                                            : null
                                        )
                                      }
                                    }
                                  })
                                }),
                                0
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "rounded-side-filter mt-2",
                              staticStyle: { "border-left": "none !important" }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-left py-2 pl-5 font-weight-bold text-uppercase titleCatFilter",
                                  class: _vm.currentCategory.productType
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("priceRange")) + " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mb-0 mt-3 pl-4 pr-2",
                              staticStyle: { height: "70px" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-none d-xl-block" },
                                [
                                  _c("vue-slider", {
                                    ref: "slider",
                                    attrs: {
                                      marks: _vm.marks1,
                                      "enable-cross": false,
                                      lazy: true,
                                      "tooltip-formatter": _vm.formatter,
                                      "dot-size": 40,
                                      process: false,
                                      min: 0,
                                      max: 2000
                                    },
                                    on: { change: _vm.searchByRange },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "dot",
                                          fn: function(ref) {
                                            return [
                                              _c("img", {
                                                staticClass:
                                                  "custom-dot cursor-pointer",
                                                attrs: {
                                                  src: require("../assets/slider-1.png"),
                                                  alt: ""
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1553753187
                                    ),
                                    model: {
                                      value: _vm.value,
                                      callback: function($$v) {
                                        _vm.value = $$v
                                      },
                                      expression: "value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "d-block d-xl-none" },
                                [
                                  _c("vue-slider", {
                                    ref: "slider",
                                    attrs: {
                                      marks: _vm.marks2,
                                      "enable-cross": false,
                                      lazy: true,
                                      "tooltip-formatter": _vm.formatter,
                                      "dot-size": 40,
                                      process: false,
                                      min: 0,
                                      max: 2000
                                    },
                                    on: { change: _vm.searchByRange },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "dot",
                                          fn: function(ref) {
                                            return [
                                              _c("img", {
                                                staticClass:
                                                  "custom-dot cursor-pointer",
                                                attrs: {
                                                  src: require("../assets/slider-1.png"),
                                                  alt: ""
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1553753187
                                    ),
                                    model: {
                                      value: _vm.value,
                                      callback: function($$v) {
                                        _vm.value = $$v
                                      },
                                      expression: "value"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.theme === 2
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-0 h-100 py-3 d-none d-md-block"
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6 row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-6",
                                  staticStyle: { "align-self": "center" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-left text-uppercase label-menu",
                                      staticStyle: { "font-size": "14px" }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("models")) + " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "col-6",
                                  staticStyle: { "align-self": "center" }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.subCategoryObjSelected,
                                          expression: "subCategoryObjSelected"
                                        }
                                      ],
                                      staticClass: "row w-100",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.subCategoryObjSelected = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          function($event) {
                                            return _vm.selectSub(
                                              _vm.subCategoryObjSelected
                                            )
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", {
                                        domProps: { value: null }
                                      }),
                                      _vm._l(_vm.subCategories, function(
                                        subCategory
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: subCategory.id,
                                            domProps: { value: subCategory }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(subCategory.name) +
                                                " "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "col-6" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-4 row",
                                    staticStyle: { "align-self": "center" }
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-left text-uppercase label-menu",
                                        class: _vm.currentCategory.productType,
                                        staticStyle: { "font-size": "14px" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("priceRange")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "col-8" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mb-0 mt-3 pl-4 pr-2",
                                      staticStyle: { height: "70px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "d-none d-xl-block" },
                                        [
                                          _c("vue-slider", {
                                            ref: "slider",
                                            attrs: {
                                              marks: _vm.marks1,
                                              "enable-cross": false,
                                              lazy: true,
                                              "tooltip-formatter":
                                                _vm.formatter,
                                              "dot-size": 40,
                                              process: false,
                                              min: 0,
                                              max: 2000
                                            },
                                            on: { change: _vm.searchByRange },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "dot",
                                                  fn: function(ref) {
                                                    return [
                                                      _c("img", {
                                                        staticClass:
                                                          "custom-dot cursor-pointer",
                                                        attrs: {
                                                          src: require("../assets/slider-1.png"),
                                                          alt: ""
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              1553753187
                                            ),
                                            model: {
                                              value: _vm.value,
                                              callback: function($$v) {
                                                _vm.value = $$v
                                              },
                                              expression: "value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "d-block d-xl-none" },
                                        [
                                          _c("vue-slider", {
                                            ref: "slider",
                                            attrs: {
                                              marks: _vm.marks2,
                                              "enable-cross": false,
                                              lazy: true,
                                              "tooltip-formatter":
                                                _vm.formatter,
                                              "dot-size": 40,
                                              process: false,
                                              min: 0,
                                              max: 2000
                                            },
                                            on: { change: _vm.searchByRange },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "dot",
                                                  fn: function(ref) {
                                                    return [
                                                      _c("img", {
                                                        staticClass:
                                                          "custom-dot cursor-pointer",
                                                        attrs: {
                                                          src: require("../assets/slider-1.png"),
                                                          alt: ""
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              1553753187
                                            ),
                                            model: {
                                              value: _vm.value,
                                              callback: function($$v) {
                                                _vm.value = $$v
                                              },
                                              expression: "value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _c("div", { staticClass: "col-6 row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-2",
                                  staticStyle: { "align-self": "center" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-left text-uppercase label-menu",
                                      staticStyle: { "font-size": "14px" }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("stoneType")) + " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "col-10" },
                                _vm._l(_vm.stoneTypes, function(stone) {
                                  return _c("img", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top",
                                        value: { content: stone.name },
                                        expression: "{ content: stone.name }",
                                        modifiers: { top: true }
                                      }
                                    ],
                                    key: stone.color + "-" + stone.shape,
                                    staticClass:
                                      "rounded-circle mt-2 cursor-pointer",
                                    style: {
                                      border: _vm.isStoneSelected(stone)
                                        ? "1px solid"
                                        : ""
                                    },
                                    attrs: {
                                      src: _vm.baseImageUrl + stone.image,
                                      height: "25",
                                      width: "25"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.selectStone(
                                          _vm.isStoneSelected(stone)
                                            ? null
                                            : stone
                                        )
                                      }
                                    }
                                  })
                                }),
                                0
                              )
                            ]),
                            _c("div", { staticClass: "col-6 row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-4 pl-0",
                                  staticStyle: { "align-self": "center" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-left text-uppercase label-menu",
                                      staticStyle: { "font-size": "14px" }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("goldColor")) + " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "col-8",
                                  staticStyle: { "align-self": "center" }
                                },
                                _vm._l(_vm.golds, function(gold) {
                                  return _c("img", {
                                    key: gold.id,
                                    staticClass:
                                      "rounded-circle mt-2 mr-2 cursor-pointer float-left",
                                    style: {
                                      border:
                                        _vm.goldSelectedId == gold.goldType
                                          ? "1px solid"
                                          : ""
                                    },
                                    attrs: {
                                      src: _vm.baseImageUrl + gold.image,
                                      height: "25",
                                      width: "25"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectGold(
                                          gold.goldType !== _vm.goldSelectedId
                                            ? gold
                                            : null
                                        )
                                      }
                                    }
                                  })
                                }),
                                0
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      class: [
                        _vm.theme === 1
                          ? "col-12 col-md-9 col-lg-10"
                          : _vm.step === 1
                          ? "col-md-12 bg-list"
                          : "col-md-12"
                      ]
                    },
                    [
                      _vm.currentCategory.productType == "GOLDSMITH"
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-alert",
                                { attrs: { variant: "warning", show: "" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("goldsmith_pieces_warning")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isAma
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "b-tabs",
                                {
                                  staticClass: "collection-tab",
                                  attrs: {
                                    "content-class": "mt-3",
                                    align: "center"
                                  }
                                },
                                [
                                  _c("b-tab", {
                                    attrs: {
                                      active: !_vm.isSectionChecked(
                                        "AMA_COLORE"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSectionsFilter([], false)
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "title",
                                          fn: function() {
                                            return [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "traditional_collections"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      2126943492
                                    )
                                  }),
                                  _c("b-tab", {
                                    attrs: {
                                      active: _vm.isSectionChecked("AMA_COLORE")
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSectionsFilter(
                                          ["AMA_COLORE"],
                                          false
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "title",
                                          fn: function() {
                                            return [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ama_color_collection"
                                                    )
                                                  ) + " "
                                                ),
                                                _c("span", {
                                                  staticClass: "new-feature"
                                                })
                                              ])
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      2633042198
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isSearching
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 d-none d-md-block text-right"
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedFilter,
                                      expression: "selectedFilter"
                                    }
                                  ],
                                  staticClass: "select-setting",
                                  class: [_vm.theme === 1 ? "mt-3" : "mt-2"],
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedFilter = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      function($event) {
                                        return _vm.sortList(_vm.selectedFilter)
                                      }
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "",
                                        disabled: "",
                                        selected: ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("orderBy")))]
                                  ),
                                  _vm._l(_vm.sortOptions, function(option) {
                                    return _c(
                                      "option",
                                      {
                                        key: option.id,
                                        domProps: { value: option.id }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("" + option.label)) +
                                            " "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "col-12 filters-tags" },
                        [
                          _vm._l(_vm.jewelSections, function(section) {
                            return _vm.isSectionChecked(section)
                              ? _c(
                                  "div",
                                  {
                                    key: section + "-filter",
                                    staticClass: "filter-tag"
                                  },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v(_vm._s(_vm.$t(section)))
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "remove-filter-icon" },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: ["fa", "times"] },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleSectionFilter(
                                                section
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm.searchJewel.minAvailability > 0
                            ? _c("div", { staticClass: "filter-tag" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(_vm._s(_vm.$t("fastDelivery")))
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "remove-filter-icon" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "times"] },
                                      on: {
                                        click: function($event) {
                                          return _vm.onChangeFastDelivery(0)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm.subCategoryFilter
                            ? _c("div", { staticClass: "filter-tag" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(_vm._s(_vm.subCategoryFilter.name))
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "remove-filter-icon" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "times"] },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectSub(null)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm.stoneFilter && _vm.stoneFilter.name
                            ? _c("div", { staticClass: "filter-tag" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(_vm._s(_vm.stoneFilter.name))
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "remove-filter-icon" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "times"] },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectStone(null)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm.stoneShapeFilter && _vm.stoneShapeFilter.name
                            ? _c("div", { staticClass: "filter-tag" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(_vm._s(_vm.stoneShapeFilter.name))
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "remove-filter-icon" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "times"] },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectStoneShape(null)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm.goldFilter
                            ? _c("div", { staticClass: "filter-tag" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("gold_" + _vm.goldFilter.goldType)
                                    )
                                  )
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "remove-filter-icon" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "times"] },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectGold(null)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm.value[0] || _vm.value[1] != 2000
                            ? _c("div", { staticClass: "filter-tag" }, [
                                _vm.value[0] && _vm.value[1] != 2000
                                  ? _c("span", { staticClass: "label" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.value[0] +
                                            " € - " +
                                            _vm.value[1] +
                                            " €"
                                        )
                                      )
                                    ])
                                  : _vm.value[0]
                                  ? _c("span", { staticClass: "label" }, [
                                      _vm._v("> " + _vm._s(_vm.value[0]) + " €")
                                    ])
                                  : _vm.value[1] != 2000
                                  ? _c("span", { staticClass: "label" }, [
                                      _vm._v("< " + _vm._s(_vm.value[1]) + " €")
                                    ])
                                  : _vm._e(),
                                _c(
                                  "span",
                                  { staticClass: "remove-filter-icon" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "times"] },
                                      on: {
                                        click: function($event) {
                                          return _vm.resetPriceRenge()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm.jewelList && _vm.jewelList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "row infinite-list" },
                            [
                              _vm._l(_vm.amaKits, function(amaKit) {
                                return _vm.isAma &&
                                  !_vm.isSectionChecked("AMA_COLORE")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "col-6 mb-3",
                                        class: [
                                          _vm.theme === 1
                                            ? "col-md-6 col-lg-4 col-xl-3"
                                            : "col-md-4 col-xl-3"
                                        ]
                                      },
                                      [
                                        _c("StarterKit", {
                                          attrs: {
                                            name: amaKit.name,
                                            label: amaKit.label
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              _vm._l(_vm.amaAriaKits, function(amaKit) {
                                return _vm.isAma &&
                                  !_vm.isSectionChecked("AMA_COLORE")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "col-6 mb-3",
                                        class: [
                                          _vm.theme === 1
                                            ? "col-md-6 col-lg-4 col-xl-3"
                                            : "col-md-4 col-xl-3"
                                        ]
                                      },
                                      [
                                        _c("StarterKit", {
                                          attrs: {
                                            name: amaKit.name,
                                            label: amaKit.label
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              _vm._l(_vm.giKits, function(giKit) {
                                return _vm.isGioielleriaItalianaB2B &&
                                  _vm.isSectionChecked("ESSENTIAL")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "col-6 mb-3",
                                        class: [
                                          _vm.theme === 1
                                            ? "col-md-6 col-lg-4 col-xl-3"
                                            : "col-md-4 col-xl-3"
                                        ]
                                      },
                                      [
                                        _c("StarterKit", {
                                          attrs: {
                                            name: giKit.name,
                                            label: giKit.label
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              _vm._l(
                                _vm.jewelList.slice(0, _vm.jewelsToShow),
                                function(jewel) {
                                  return jewel.productType !== "KIT" ||
                                    !_vm.isAma ||
                                    !_vm.showOnlyPublicPrice
                                    ? _c(
                                        "div",
                                        {
                                          key: jewel.sku,
                                          staticClass:
                                            "col-6 mb-3 cursor-pointer d-flex",
                                          class: [
                                            _vm.theme === 1
                                              ? "col-md-6 col-lg-4 col-xl-3"
                                              : "col-md-4 col-xl-3"
                                          ],
                                          attrs: { id: "jewel-" + jewel.sku },
                                          on: {
                                            click: function($event) {
                                              return _vm.goToJewelDetail(jewel)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex-grow-1",
                                              class: [
                                                _vm.theme === 1
                                                  ? "border-item"
                                                  : "border-item-2",
                                                _vm.currentCategory.productType
                                              ]
                                            },
                                            [
                                              _vm.isGioielleriaItalianaB2B
                                                ? _c(
                                                    "div",
                                                    { staticClass: "icons" },
                                                    [
                                                      jewel.fastDeliveryItems &&
                                                      jewel.fastDeliveryItems
                                                        .length > 0
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "fast-delivery-icon"
                                                            },
                                                            [
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "tooltip",
                                                                    rawName:
                                                                      "v-tooltip",
                                                                    value: _vm.$t(
                                                                      "fastDelivery"
                                                                    ),
                                                                    expression:
                                                                      "$t('fastDelivery')"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  src:
                                                                    _vm.baseImageUrl +
                                                                    "/configuratore/icons/fast_delivery.png"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      jewel.jewelSections &&
                                                      jewel.jewelSections.includes(
                                                        "BESTSELLER"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "bestseller-icon"
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "tooltip",
                                                                      rawName:
                                                                        "v-tooltip",
                                                                      value: _vm.$t(
                                                                        "bestseller"
                                                                      ),
                                                                      expression:
                                                                        "$t('bestseller')"
                                                                    }
                                                                  ],
                                                                  attrs: {
                                                                    icon: [
                                                                      "fa",
                                                                      "trophy"
                                                                    ]
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "position-relative bg-white image-list"
                                                },
                                                [
                                                  jewel.images &&
                                                  jewel.images.length > 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "swiper",
                                                              rawName:
                                                                "v-swiper",
                                                              value: _vm.getJewelSwiperOptions(
                                                                jewel.sku
                                                              ),
                                                              expression:
                                                                "getJewelSwiperOptions(jewel.sku)"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "swiper-container jewel-swiper-container",
                                                          attrs: {
                                                            id:
                                                              "jewel-swiper-" +
                                                              jewel.sku
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "swiper-wrapper jewel-swiper"
                                                            },
                                                            _vm._l(
                                                              jewel.images,
                                                              function(
                                                                img,
                                                                idx
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: idx,
                                                                    staticClass:
                                                                      "swiper-slide"
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "jewel-image",
                                                                      attrs: {
                                                                        src:
                                                                          _vm.baseImageUrl +
                                                                          img,
                                                                        loading:
                                                                          "lazy"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                          _c("div", {
                                                            staticClass:
                                                              "swiper-pagination",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                              },
                                                              pointerdown: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _c("img", {
                                                        staticClass:
                                                          "jewel-image",
                                                        attrs: {
                                                          src: jewel.image
                                                            ? _vm.baseImageUrl +
                                                              jewel.image
                                                            : jewel.images &&
                                                              jewel.images
                                                                .length
                                                            ? _vm.baseImageUrl +
                                                              jewel.images[0]
                                                            : ""
                                                        }
                                                      }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "name-back"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "name-space",
                                                          class:
                                                            jewel.productType
                                                        },
                                                        [
                                                          _vm.isAma
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mb-0 sku",
                                                                  class:
                                                                    jewel.productType
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      jewel.sku
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mb-0 name",
                                                              class:
                                                                jewel.productType
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  jewel.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm.buildYourJewelMode
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "value"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "from"
                                                                        ) +
                                                                          " " +
                                                                          jewel.minGoldWeight +
                                                                          " "
                                                                      )
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "text-transform":
                                                                          "lowercase"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "g"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "value"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "from"
                                                                        )
                                                                      ) +
                                                                      " € "
                                                                  ),
                                                                  !_vm.showOnlyPublicPrice
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.retailPerc ===
                                                                                1
                                                                                ? parseFloat(
                                                                                    jewel.minPrice *
                                                                                      _vm.vat
                                                                                  )
                                                                                    .toFixed(
                                                                                      0
                                                                                    )
                                                                                    .toLocaleString(
                                                                                      "it-it"
                                                                                    )
                                                                                : parseFloat(
                                                                                    (
                                                                                      jewel.minPrice *
                                                                                      _vm.retailPerc
                                                                                    ).toFixed(
                                                                                      0
                                                                                    )
                                                                                  ).toLocaleString(
                                                                                    "it-it"
                                                                                  )
                                                                            ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm.showOnlyPublicPrice
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                parseFloat(
                                                                                  jewel.listPrice.toFixed(
                                                                                    0
                                                                                  )
                                                                                ).toLocaleString(
                                                                                  "it-it"
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  !_vm.buildYourJewelMode &&
                                                  jewel.stoneColors &&
                                                  jewel.stoneColors.length > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "jewel-stone-colors w-100",
                                                          staticStyle: {
                                                            bottom: "0px",
                                                            "padding-bottom":
                                                              "4px"
                                                          },
                                                          style: {
                                                            "background-color":
                                                              _vm.theme === 1
                                                                ? ""
                                                                : "white"
                                                          }
                                                        },
                                                        _vm._l(
                                                          jewel.stoneColors,
                                                          function(stoneColor) {
                                                            return _c("img", {
                                                              key: stoneColor,
                                                              staticClass:
                                                                "rounded-circle cursor-pointer inside-stone",
                                                              attrs: {
                                                                src:
                                                                  _vm.baseImageUrl +
                                                                  _vm.getStoneByColor(
                                                                    stoneColor,
                                                                    jewel.stoneShapes &&
                                                                      jewel
                                                                        .stoneShapes
                                                                        .length
                                                                      ? jewel
                                                                          .stoneShapes[0]
                                                                      : null
                                                                  ).image
                                                              }
                                                            })
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                  _vm.buildYourJewelMode &&
                                                  jewel.stoneShapes &&
                                                  jewel.stoneShapes.length > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "jewel-stone-colors w-100",
                                                          staticStyle: {
                                                            bottom: "0px",
                                                            "padding-bottom":
                                                              "4px"
                                                          },
                                                          style: {
                                                            "background-color":
                                                              _vm.theme === 1
                                                                ? ""
                                                                : "white"
                                                          }
                                                        },
                                                        _vm._l(
                                                          jewel.stoneShapes,
                                                          function(stoneShape) {
                                                            return _c("img", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "tooltip",
                                                                  rawName:
                                                                    "v-tooltip.top",
                                                                  value: {
                                                                    content: stoneShape
                                                                  },
                                                                  expression:
                                                                    "{ content: stoneShape }",
                                                                  modifiers: {
                                                                    top: true
                                                                  }
                                                                }
                                                              ],
                                                              key: stoneShape,
                                                              staticClass:
                                                                "rounded-circle cursor-pointer inside-stone",
                                                              attrs: {
                                                                src: _vm.getShapeImage(
                                                                  stoneShape
                                                                )
                                                              }
                                                            })
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 text-md-right text-center"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn text-uppercase",
                                      class: [
                                        "btn-show-" + _vm.theme,
                                        _vm.currentCategory.productType
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.showMore()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.jewelList.length >
                                              _vm.jewelsToShow
                                              ? _vm.$t("showMore")
                                              : _vm.$t("showLess")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm.jewelList && _vm.jewelList.length === 0
                        ? _c("div", { staticClass: "row mt-5" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 mb-3 text-center justify-content-center"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/slider-1.png"),
                                    alt: "",
                                    height: "100",
                                    width: "100"
                                  }
                                }),
                                _c("h1", [_vm._v(_vm._s(_vm.$t("noJewels")))])
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm.isSearching
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 mb-3 text-center justify-content-center mt-5"
                  },
                  [
                    _c("DoubleBounce", {
                      attrs: { background: "#00274F", size: "100px" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }